import React, { useState } from 'react';
import { ShoppingCartIcon } from './Icons';

const DishCard = ({
    item,
    favorites,
    handleAddToFavorites,
    activeTooltip,
    setActiveTooltip,
    description,
    setDescription,
    addToCart,
    cartLoading,
    isFromAddItem,
    currentSeatingId,
    openScheduleModal
}) => {
    const isOutOfStock = Number(item.balanceQuantity) <= 0;

    const handleToggleTooltip = (dishId, desc) => {
        setActiveTooltip(activeTooltip === dishId ? null : dishId);
        setDescription(desc || "");
    };

    return (
        <div className="menu-dish-card">
            <button
                className="dish-fav-btn"
                onClick={e => { e.stopPropagation(); handleAddToFavorites(item.dishId); }}
            >
                <i className={`fa-${favorites.includes(item.dishId) ? 'solid' : 'regular'} fa-heart`}
                    style={{ color: favorites.includes(item.dishId) ? '#dc2626' : '#ee6521' }} />
            </button>

            <img
                src={item.dishImage || "https://via.placeholder.com/300x180"}
                alt={item.dishName}
                className="dish-img"
            />

            <div className="dish-body">
                <div className="dish-name-row">
                    <h5 className="dish-name">{item.dishName}</h5>
                    <button
                        className="dish-info-btn"
                        onClick={e => { e.stopPropagation(); handleToggleTooltip(item.dishId, item.description); }}
                    >i</button>
                    <span className={`dish-tag-dot ${item.tag === 'Veg' ? 'veg' : 'nonveg'}`} />
                </div>

                {activeTooltip === item.dishId && (
                    <div className="dish-tooltip">{description || 'No description available.'}</div>
                )}

                <div className="dish-price-row">
                    {item.effectivePrice !== undefined && item.price > 0 ? (
                        <>
                            <span className="dish-price-original">₹{item.price}</span>
                            <span className="dish-price-effective">₹{item.effectivePrice.toFixed(2)}</span>
                        </>
                    ) : (
                        <span className="dish-price-effective">₹{item.price}</span>
                    )}
                </div>

                {isFromAddItem && currentSeatingId ? (
                    <button
                        onClick={() => addToCart(item)}
                        disabled={isOutOfStock || cartLoading}
                        className={`dish-add-btn ${(isOutOfStock || cartLoading) ? 'disabled' : ''}`}
                    >
                        
                        <ShoppingCartIcon />
                        {isOutOfStock ? 'Out of Stock' : cartLoading ? 'Adding...' : 'Add to Cart'}
                    </button>
                ) : (
                    <button className="dish-book-btn" onClick={openScheduleModal}>
                        Book Table
                    </button>
                )}
            </div>
        </div>
    );
};

export default DishCard;